//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"AllInstances",1,0],[0,"Angle",1,0],[1,"AngleExp",0,"Expression",0],[0,"FirstOffset",1,0],[1,"FirstOffsetExp",0,"Expression",0],[0,"Method",1,0],[0,"Option",1,0],[0,"ReverseOffsets",1,0],[0,"SaveFeature",1,0],[0,"SecondOffset",1,0],[1,"SecondOffsetExp",0,"Expression",0],[0,"SmartCollector",1,"ScCollector",0],[0,"Tolerance",1,0]],[[[],"CreatePreview",{R_:{preview_body:''}},0,0]],[]];
SPLM.Features.ChamferBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ChamferBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ChamferBuilder.ChamferOption = Object.freeze({
    "SymmetricOffsets" : "SymmetricOffsets", "TwoOffsets" : "TwoOffsets", "OffsetAndAngle" : "OffsetAndAngle"});

SPLM.Features.ChamferBuilder.OffsetMethod = Object.freeze({
    "EdgesAlongFaces" : "EdgesAlongFaces", "FacesAndTrim" : "FacesAndTrim"});

export default SPLM;